<template>
  <div class="listing-form general-information margin-auto">
    <Card class="general-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-create"/>
        <div><p style="color:#000;font-weight:bold">General</p></div>
      </div>
      <div>
        <Form ref="GeneralInformationForm" :model="value" :rules="formRules" label-position="top">
          <FormItem label="Company name" prop="name">
            <Input v-model="value.name" class="k-input"/>
          </FormItem>
          <FormItem label="Tagline" prop="tagline">
            <Input v-model="value.tagline" class="k-input"/>
          </FormItem>
          <FormItem prop="cover_photo">
            <span slot="label">
              Cover photo
              <Tooltip max-width="300" placement="top" content="1920x1080px recommended">[?]</Tooltip>
            </span>
            <div v-if="value.cover_photo" class="pos-relative" style="width:fit-content">
              <Avatar shape="square" :src="value.cover_photo" size="150" />
              <Button class="k-btn-2" v-if="value.cover_photo" @click="value.cover_photo = null" size="small" style="bottom:5px;position:absolute;right:30%;background:#ff0000c4;color:#ffffff;border:none;">Remove</Button>
            </div>
            <UploadFile v-else class="file-upload" @upload="(file) => {value.cover_photo = file }">
              <div slot="content" class="drag-photo clickable" v-if="!value.cover_photo" style="padding: 40px 60px; border: 1px dashed #ccc;">
                <Icon type="md-cloud-upload" size="20" color="#ccc"/>
              </div>
            </UploadFile>
          </FormItem>
          <FormItem prop="logo">
            <span slot="label">
              Company logo
              <Tooltip max-width="300" placement="top" content="240x240px recommended">[?]</Tooltip>
            </span>
            <div v-if="value.logo" class="pos-relative" style="width:fit-content">
              <Avatar shape="square" :src="value.logo" size="150" />
              <Button class="k-btn-2" v-if="value.logo" @click="value.logo = null" size="small" style="bottom:5px;position:absolute;right:30%;background:#ff0000c4;color:#ffffff;border:none;">Remove</Button>
            </div>
            <UploadFile v-else class="file-upload" @upload="(file) => {value.logo = file }">
              <div slot="content" class="drag-photo clickable" v-if="!value.logo" style="padding: 40px 60px; border: 1px dashed #ccc;">
                <Icon type="md-cloud-upload" size="20" color="#ccc"/>
              </div>
            </UploadFile>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import UploadFile from '@/components/ui/UploadFile'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    UploadFile
  },

  data () {
    return {
      formRules: {
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        tagline: [
          { required: true, message: 'The tagline cannot be empty', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: 'The logo cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleSubmit () {
      this.$refs.GeneralInformationForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.general-information {
  max-width:700px;
  .general-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.general-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
